export default __webpack_public_path__ + "static/media/image_level-risks.0baa6fc4.svg";